if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        const darkType = this.elements.thumbnails?.dataset?.marktype || '';
        const accountNum = this.elements.thumbnails?.dataset?.accountnum || 12;

        this.thumbsOptions = darkType === 'dot' && window.innerWidth < 768 ? {
          slidesPerView: accountNum >= 12 ? 12 : accountNum,
          spaceBetween: 10,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
          centeredSlides: true,          // 激活slide居中
          slideToClickedSlide: true,     // 点击slide自动滑到并居中
          centeredSlidesBounds: true
        } : {
          slidesPerView: 5.7,
          // breakpoints: {
          //   461: {
          //     slidesPerView: 5,
          //   },
          // },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
          const scrollDom = this.querySelector('.vertical-carousel-test-scroll');
          if (window.innerWidth >= 768 && scrollDom) {
            this.setProductScrollDomEvent(scrollDom, null)
            console.log('111')
          }
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { currIndex } = this.lightbox.pswp;
            if (this.sliderInstance.slider.realIndex !== currIndex) {
              this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
            }
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;
          const realIndex = swiper.realIndex;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(realIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);

        const scrollDom = this.querySelector('.vertical-carousel-test-scroll');
        if (window.innerWidth >= 768 && scrollDom) {
          this.setProductScrollDomEvent(scrollDom, selected)
        }
      }

      setProductScrollDomEvent(scrollDom, activeDom) {
        // 获取当前元素index：'data-swiper-slide-index'，当前元素高度
        const currentIndex = activeDom ? activeDom.getAttribute('data-swiper-slide-index') : 0;
        // 获取元素的所有直接子元素
        const childList = scrollDom.children;
        // 将HTMLCollection转换为数组，并使用filter方法筛选出具有特定类名的元素
        const swipeChildren = Array.from(childList).filter(childItem => childItem.classList.contains('product__thumbs-item'));
        // 单个元素宽度
        const itemWidth = swipeChildren[0].clientWidth;
        // 单个元素高度
        const itemHeight = swipeChildren[0].clientHeight;
        const itemSeatHeight = itemHeight + 10;  // 10是margin-bottom的值
        // 获取筛选后的元素数量
        const childCount = swipeChildren.length;
        // 获取元素的总高度和可见高度
        const scrollHeight = scrollDom.scrollHeight;
        const clientHeight = scrollDom.clientHeight;
        // 计算最大垂直滚动距离
        const maxScrollTop = scrollHeight - clientHeight;
        // 计算滚动元素能展示几个子元素
        const maxShowNum = clientHeight / itemSeatHeight;
        const maxIntNum = Math.ceil(maxShowNum / 2)
        // 设置元素的滚动距离(根据activeDom的data-swiper-slide-index值以及最大滚动距离设置)
        // $(scrollDom).animate({ scrollTop: 0 }, 'slow');可以替换为毫秒数
        let finalScrollTop = 0
        if (currentIndex + 1 <= maxIntNum) {
          // console.log(currentIndex, maxShowNum, '距离0的滚动')
          finalScrollTop = 0
        } else if (currentIndex >= childCount - maxIntNum ) {
          // console.log(currentIndex, maxShowNum, '距离最大的滚动')
          finalScrollTop = maxScrollTop
        } else {
          const scrollDistance = itemSeatHeight * (currentIndex - maxIntNum + 1)
          // console.log(scrollDistance, '其他滚动距离')
          finalScrollTop = scrollDistance
        }

        const scrollWrap = this.querySelector('.thumbnails__scroll_up-down');
        const scrollUpBtn = this.querySelector('.thumbnails__scroll_up');
        const scrollDownBtn = this.querySelector('.thumbnails__scroll_down');
        $(scrollDom).off('scroll');
        $(scrollUpBtn).off();
        $(scrollDownBtn).off();
        if (maxScrollTop > 0) {
          $(scrollWrap).css({
            "position": "absolute",
            "top": 0,
            "left": Math.floor((itemWidth - 24) / 2) + "px",
            "bottom": 0,
            "width": "24px",
            "pointer-events": "none",
            "display": "flex",
            "flex-direction": "column",
            "justify-content": "space-between",
          });
        } else {
          $(scrollWrap).css({
            "display": "none",
          })
        }
        if (finalScrollTop > 1) {
          $(scrollUpBtn).css({
            "display": "inline-block",
          })
        } else {
          $(scrollUpBtn).css({
            "display": "none",
          })
        }
        if (finalScrollTop < maxScrollTop - 1) {
          $(scrollDownBtn).css({
            "display": "inline-block",
          })
        } else {
          $(scrollDownBtn).css({
            "display": "none",
          })
        }
        $(scrollDom).animate({ scrollTop: finalScrollTop }, 300, 'linear', () => {
          $(scrollDom).on('scroll', () => {
            this.setListnerScrollTop()
          })
          $(scrollUpBtn).on('click', () => {
            this.setSwipeWrapScrollTop('up')
          });
          $(scrollDownBtn).on('click', () => {
            this.setSwipeWrapScrollTop('down')
          });          
        });
      }

      setListnerScrollTop() {
        const scrollDom = this.querySelector('.vertical-carousel-test-scroll');
        if (window.innerWidth >= 768 && scrollDom) {
          // 获取元素的总高度和可见高度
          const scrollHeight = scrollDom.scrollHeight;
          const clientHeight = scrollDom.clientHeight;
          // 计算最大垂直滚动距离
          const maxScrollTop = scrollHeight - clientHeight;
          // 获取当前滚动距离
          const currentScrollTop = $(scrollDom).scrollTop();
          // 获取up和down元素
          const scrollUpBtn = this.querySelector('.thumbnails__scroll_up');
          const scrollDownBtn = this.querySelector('.thumbnails__scroll_down');
          if (currentScrollTop > 1) {
            $(scrollUpBtn).css({
              "display": "inline-block",
            })
          } else {
            $(scrollUpBtn).css({
              "display": "none",
            })
          }
          if (currentScrollTop < maxScrollTop - 1) {
            $(scrollDownBtn).css({
              "display": "inline-block",
            })
          } else {
            $(scrollDownBtn).css({
              "display": "none",
            })
          }
        }
      }

      setSwipeWrapScrollTop(clickType) {
        const scrollDom = this.querySelector('.vertical-carousel-test-scroll');
        if (window.innerWidth >= 768 && scrollDom) {
          // 获取元素的所有直接子元素
          const childList = scrollDom.children;
          // 将HTMLCollection转换为数组，并使用filter方法筛选出具有特定类名的元素
          const swipeChildren = Array.from(childList).filter(childItem => childItem.classList.contains('product__thumbs-item'));
          // 单个元素高度
          const itemHeight = swipeChildren[0].clientHeight;
          const itemSeatHeight = itemHeight + 10;  // 10是margin-bottom的值
          // 获取元素的总高度和可见高度
          const scrollHeight = scrollDom.scrollHeight;
          const clientHeight = scrollDom.clientHeight;
          // 计算最大垂直滚动距离
          const maxScrollTop = scrollHeight - clientHeight;
          // 获取up和down元素
          const scrollUpBtn = this.querySelector('.thumbnails__scroll_up');
          const scrollDownBtn = this.querySelector('.thumbnails__scroll_down');
          // 获取当前滚动距离
          const currentScrollTop = $(scrollDom).scrollTop()

          if (clickType === 'up') {
            const newScrollTop = currentScrollTop - itemSeatHeight > 0 ? currentScrollTop - itemSeatHeight : 0;
            $(scrollDom).off('scroll');
            $(scrollDom).animate({ scrollTop: newScrollTop }, 200, 'linear', () => {
              $(scrollDom).on('scroll', () => {
                this.setListnerScrollTop()
              })
            });
            if (newScrollTop > 1) {
              $(scrollUpBtn).css({
                "display": "inline-block",
              })
            } else {
              $(scrollUpBtn).css({
                "display": "none",
              })
            }
            if (newScrollTop < maxScrollTop - 1) {
              $(scrollDownBtn).css({
                "display": "inline-block",
              })
            } else {
              $(scrollDownBtn).css({
                "display": "none",
              })
            }
          } else if (clickType === 'down') {
            const newScrollTop = currentScrollTop + itemSeatHeight < maxScrollTop ? currentScrollTop + itemSeatHeight : maxScrollTop;
            $(scrollDom).off('scroll');
            $(scrollDom).animate({ scrollTop: newScrollTop }, 200, 'linear', () => {
              $(scrollDom).on('scroll', () => {
                this.setListnerScrollTop()
              })
            });
            if (newScrollTop > 1) {
              $(scrollUpBtn).css({
                "display": "inline-block",
              })
            } else {
              $(scrollUpBtn).css({
                "display": "none",
              })
            }
            if (newScrollTop < maxScrollTop - 1) {
              $(scrollDownBtn).css({
                "display": "inline-block",
              })
            } else {
              $(scrollDownBtn).css({
                "display": "none",
              })
            }
          }
        }
      }

      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

        if (this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1);
        } else {
          this.sortMediaItems(variant);
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
